"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPostSportDigestOptionDto = instanceOfPostSportDigestOptionDto;
exports.PostSportDigestOptionDtoFromJSON = PostSportDigestOptionDtoFromJSON;
exports.PostSportDigestOptionDtoFromJSONTyped = PostSportDigestOptionDtoFromJSONTyped;
exports.PostSportDigestOptionDtoToJSON = PostSportDigestOptionDtoToJSON;
exports.PostSportDigestOptionDtoToJSONTyped = PostSportDigestOptionDtoToJSONTyped;
var DigestCopyDto_1 = require("./DigestCopyDto");
/**
 * Check if a given object implements the PostSportDigestOptionDto interface.
 */
function instanceOfPostSportDigestOptionDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('label' in value) || value['label'] === undefined)
        return false;
    return true;
}
function PostSportDigestOptionDtoFromJSON(json) {
    return PostSportDigestOptionDtoFromJSONTyped(json, false);
}
function PostSportDigestOptionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'label': (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['label']),
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    };
}
function PostSportDigestOptionDtoToJSON(json) {
    return PostSportDigestOptionDtoToJSONTyped(json, false);
}
function PostSportDigestOptionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'label': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['label']),
        'sortOrder': value['sortOrder'],
    };
}
